import React from 'react';
import { gengetURLTEST, genURL, genURLTEST } from '../../../_getjson';
import axios from 'axios';
import { DataGrid, GridToolbarQuickFilter, GridToolbar, } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import SelectStkJobOrderSub from './SelectStkJobOrderSub';
import FullScreendialogs from '../../../PopUp/FullScreendialogs/FullScreen'
export default function SelectStkJobOrder(props) {

    const {
        multiselect
    } = props
    const [loading, setLoading] = React.useState(true)
    const [data, setData] = React.useState([])
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [state, setState] = React.useState({
        openDialog: false,
        mainData: [],
        titleDialog: "เลือกรายการ"
    })

    // const rows = [
    //     { id: 1, code: 'Hello', name: 'World' },
    //     { id: 2, code: 'DataGridPro', name: 'is Awesome' },
    //     { id: 3, code: 'MUI', name: 'is Amazing' },
    // ];

    React.useEffect(() => {
        getData();
        return () => {
        }
    }, [])

    const getData = async () => {
        setLoading(true)
        //   let url = `CSUNIT/All?`
        let url = genURL(`csstkjoborder/GetJobData?`)
        console.log(url);
        await axios.get(url).then(val => {
            console.log(val.data)
            setData(val.data)
        })
        await setLoading(false)
        //   await setData(rows)
    }

    const columns = [
        { field: 'id', headerName: 'ID', width: 90, hide: true },
        {
            field: 'DOCNO',
            headerName: 'ใบสั่งผลิต',
            width: 30,
            editable: false,
            flex: 1
        },
        {
            field: 'DOCDATE',
            headerName: 'วันที่สั่งผลิต',
            width: 150,
            editable: false,
            flex: 1
        },

        {
            field: 'ARNAMEX',
            headerName: 'พนักงาน',
            width: 150,
            editable: false,
            flex: 0
        },
        {
            field: 'REMARK',
            headerName: 'หมายเหตุ',
            width: 250,
            editable: false,
            flex: 0
        },
        {
            field: 'ARCODEX',
            headerName: 'ลูกค้า',
            width: 250,
            editable: false,
            flex: 0
        },
    ];

    const handleDoubleClick = async (e) => {
        // console.log(selectionModel); 
        // f
        let result = []
        if (selectionModel.length > 0) {
            result = await data.filter((elem) => {
                return selectionModel.some((ele) => {
                    return ele === elem.id
                });
            });
        } else {
            await result.push(e.row)
        }
        await setState((prevState) => ({
            ...prevState,
            openDialog: true,
            mainData: result
        }
        ))
    }

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                }}
            >
                <GridToolbarQuickFilter />
            </Box>
        );
    }
    const resultSubData = (e) => {
        // console.log(e)
        setState((prevState) => ({
            ...prevState,
            openDialog: false
        }))
        props.resultData(e)
    }
    const closeDialogs = (e) => {
        //  console.log(e);
        setState((prevState) => ({
            ...prevState,
            openDialog: false
        }))
    }


    return (
        <>
            <Box sx={{ height: 400, width: '100%', mt: 2 }}>
                {loading == true ? "กำลังโหลด..." :
                    <DataGrid
                        rows={data}
                        columns={columns}

                        sx={{
                            fontFamily: "Customfont !important"
                        }}
                        disableColumnFilter
                        disableColumnSelector
                        disableDensitySelector
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10,
                                },
                            },
                            // filter: {
                            //     filterModel: {
                            //         items: [],
                            //         quickFilterValues: ['quick', 'filter'],
                            //     },
                            // },
                        }}
                        pageSizeOptions={[10]}

                        checkboxSelection={multiselect}
                        disableSelectionOnClick
                        onSelectionModelChange={(newSelectionModel) => {
                            setSelectionModel(newSelectionModel);
                        }}
                        selectionModel={selectionModel}
                        onRowDoubleClick={e => handleDoubleClick(e)}
                        //  onRowClick={e => handleClick(e)}
                        components={{ Toolbar: QuickSearchToolbar }}
                    />}

                <FullScreendialogs
                    open={state.openDialog}
                    title={state.titleDialog}
                    closeDialog={e => closeDialogs(e)}>
                    <SelectStkJobOrderSub resultData={e => resultSubData(e)} dataMain={state.mainData} multiselect={true} />
                </FullScreendialogs>
            </Box>
        </>
    )

}
SelectStkJobOrder.propTypes = { multiselect: PropTypes.bool, }
SelectStkJobOrder.defaultProps = {
    multiselect: false
};